import { useQuery } from "@tanstack/react-query";
import { GenericErrorType } from "../../models/LionError";
import { useApiClient } from "../apiClient/apiClient";
import { PublicCommune } from "./communeApi.types";

/**
 * Custom hook to fetch public active communes for citizen fault reporting.
 * Communes are cached for 10 minutes since municipality metadata rarely changes within a session.
 *
 * @returns TanStack Query result containing the list of PublicCommune items
 */
export function usePublicCommunes() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ["publicCommunes"],
    queryFn: () => apiClient.get<PublicCommune[]>("v2/communes/public", GenericErrorType.UNCRITICAL),
    staleTime: 1000 * 60 * 10,
    retry: 2,
  });
}
